import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=cfc086dc&scoped=true"
var script = {}
import style0 from "./main-header.vue?vue&type=style&index=0&id=cfc086dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc086dc",
  null
  
)

export default component.exports